var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"option-element",class:{
    'option-selected': _vm.selected,
    'option-focused': _vm.focused,
    'option-disabled': _vm.disabled,
  },attrs:{"tabindex":"0","role":"option","aria-selected":_vm.selected.toString()},on:{"click":function($event){return _vm.$emit('select', _vm.option)}}},[_vm._t("option",function(){return [_c('span',{style:(_vm.optionStyle)},[_vm._v(" "+_vm._s(_vm.option[_vm.optionLabelName])+" ")])]},{"option":_vm.option})],2)}
var staticRenderFns = []

export { render, staticRenderFns }